import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.tooltip-trigger').forEach(trigger => {
      const tooltip = document.getElementById(trigger.getAttribute('aria-describedby'));
      if (!tooltip) return;

      const show = () => {
        tooltip.classList.remove('hidden', 'opacity-0');
        tooltip.classList.add('opacity-100');
      };
      const hide = () => {
        tooltip.classList.remove('opacity-100');
        tooltip.classList.add('opacity-0');
        tooltip.addEventListener('transitionend', () => tooltip.classList.add('hidden'), { once: true });
      };

      trigger.addEventListener('mouseenter', show);
      trigger.addEventListener('focus', show);
      trigger.addEventListener('mouseleave', hide);
      trigger.addEventListener('blur', hide);
    });
  }
}
